/** MODULES */
import { Provider } from 'react-redux';
import store from './../redux/store';
import { useRouter } from 'next/router';
import { AppProps } from 'next/app';
import dynamic from 'next/dynamic';

/** STYLES */
import './../styles/index.scss';
import '@dotpe/additional-pages/dist/styles/index.scss';
import { SSRSelectorContext } from '@/redux/useSSRSelector';
import { WidgetDndContext } from 'src/context/WidgetDndContext';
import { getGlobalStyleString } from 'src/components/Layout/utils';
import Head from 'next/head';
import { useEffect } from 'react';

/** LAZY LOADED */
const WebsiteBuilderComponent = dynamic(
  () => import('@/components/WebsiteBuilderComponents'),
  { ssr: false }
);

function MyApp(appProps: AppProps<any>) {
  const { Component, pageProps } = appProps;
  const router = useRouter();

  const domain =
    pageProps?.domain || pageProps?.ssrStore?.storeReducer?.store?.domain || '';
  const path = pageProps?.ssrStore?.commonReducer?.path || router.pathname;
  const isWidgetRoute = path?.includes('/widgets');
  const globalStyle = pageProps?.ssrStore?.jsonWidgetsReducer?.globalStyle;
  const userAgent = pageProps?.userAgent || '';
  const { globalStyleString, fontURls } = getGlobalStyleString({ globalStyle });

  useEffect(() => {
    import('../styles/common/fonts.scss' as string);
  }, []);

  useEffect(() => {
    // Only runs on client
    import('../../sentry.client.config')
      .then(({ initSentry }) => initSentry())
      .catch((err) => {
        console.error('Failed to init Sentry:', err);
      });
  }, []);

  return (
    <>
      <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        {!isWidgetRoute && (
          <>
            {fontURls?.map((fontData, idx) => (
              <link key={idx} rel="stylesheet" href={fontData.fontCdn} />
            ))}
            <style>{globalStyleString}</style>
          </>
        )}
      </Head>
      <Provider store={store}>
        <SSRSelectorContext.Provider value={{ domain, userAgent, path }}>
          {isWidgetRoute ? (
            <WebsiteBuilderComponent Component={Component} pageProps={pageProps} />
          ) : (
            <WidgetDndContext>
              <Component {...pageProps} />
            </WidgetDndContext>
          )}
        </SSRSelectorContext.Provider>
      </Provider>
    </>
  );
}

export default MyApp;

// import { Provider } from 'react-redux';
// import store from './../redux/store';
// import { useRouter } from 'next/router';
// import { AppProps } from 'next/app';
// import dynamic from 'next/dynamic';
// import { useEffect } from 'react';

// import { SSRSelectorContext } from '@/redux/useSSRSelector';

// const WebsiteBuilderComponent = dynamic(
//   () => import('@/components/WebsiteBuilderComponents'),
//   { ssr: false }
// );

// const DynamicWidgetDndContext = dynamic(
//   () => import('src/context/WidgetDndContext').then((mod) => mod.WidgetDndContext),
//   { ssr: true }
// );

// function MyApp(appProps: AppProps<any>) {
//   const { Component, pageProps } = appProps;
//   const router = useRouter();
//   const isWidgetRoute = router.pathname.includes('/widgets');

//   useEffect(() => {
//     import('../../sentry.client.config')
//       .then(({ initSentry }) => initSentry())
//       .catch((err) => {
//         console.error('Failed to init Sentry:', err);
//       });
//   }, []);

//   useEffect(() => {
//     if (!isWidgetRoute) {
//       import('@dotpe/additional-pages/dist/styles/index.scss' as string);
//     }
//   }, [isWidgetRoute]);

//   useEffect(() => {
//     import('./../styles/index.scss' as string);
//   }, []);

//   const domain =
//     pageProps?.domain || pageProps?.ssrStore?.storeReducer?.store?.domain || '';
//   const userAgent = pageProps?.userAgent || '';

//   return (
//     <Provider store={store}>
//       <SSRSelectorContext.Provider value={{ domain, userAgent }}>
//         {isWidgetRoute ? (
//           <WebsiteBuilderComponent Component={Component} pageProps={pageProps} />
//         ) : (
//           <DynamicWidgetDndContext>
//             <Component {...pageProps} />
//           </DynamicWidgetDndContext>
//         )}
//       </SSRSelectorContext.Provider>
//     </Provider>
//   );
// }

// export default MyApp;
